import Stars02 from "@uui/Stars02";

import styled from "@mui/material/styles/styled";

import Stack, { StackProps } from "@rui/Stack";

export const OverlayOuterContainer = styled(Stack)(() => ({
  height: "100%",
  width: "100%",
  padding: "16px",
}));

export const ContentContainer = styled((props: StackProps) => (
  <Stack variant="center" {...props} spacing={2} />
))(({ theme }) => ({
  textAlign: "center",
  color: theme.palette.shades.neutral[600],
  maxWidth: "400px",
}));

export const MeetingRecapCTA = styled((props: StackProps) => (
  <Stack spacing={1} {...props} />
))(({ theme }) => ({
  backgroundColor: "#FFF",
  border: `2px solid ${theme.palette.shades.primary[500]}`,
  borderRadius: "8px",
  padding: "16px",
  textAlign: "initial",
  marginTop: "32px !important",
  maxWidth: "404px",
}));

export const StarIcon = styled(Stars02)(({ theme }) => ({
  height: "16px",
  width: "16px",
  color: theme.palette.shades.primary[500],
}));
